import { Injectable } from '@angular/core';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';

@Injectable({ providedIn: 'root' })
export class MessageHandlerService {
  constructor(private toastrService: NbToastrService) {}

  handle(title: string, message: string, toastOptions?: any) {
    if (message) {
      this.toastrService.show(message, title, {
        destroyByClick: true,
        duration: 2000,
        position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
        preventDuplicates: false,
        status: 'success',
        ...(toastOptions || {}),
      });
    }
  }
}
